import { jsonParseLinter } from '@codemirror/lang-json';
import { linter } from '@codemirror/lint';

const JsonLinter = () => linter(jsonParseLinter());

export default JsonLinter;